import React, { Component } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { logout } from "../../../actions/baseActions";
import { setObj } from "../../../actions/noteActions";
import Breadcrumb from "../../../components/Breadcrumb";
import ContentComponentMedia from "../../../components/Content/ContentMedia";
import Loading from "../../../components/Loading";
import ProtectedRoute from "../../../components/ProtectedRoute";
import URL from "../../../config/api";
import axios from "../../../config/axios";

class ContentList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      type: 9,
      typeName: "Todos",
      typeIcon: "",
      typeColor: "",
      types: [],
      word: ""
    };
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.initContent();
  }

  initContent() {
    this.setState({ loading: true });
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    if (this.props.location.state?.word) {
      this.setState({ word: this.props.location.state.word });
    }
    const { type } = this.props.match.params;
    axios
      .get(`${URL.api}content/type/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        let responseData = resp.data.data;
        this.setState({ types: responseData, loading: false });
      });

    if (type) {
      this.setState({ type });
    }
  }

  render() {
    return (
      <>
        <Breadcrumb current={this.props.currentRoute} />
        {this.state.loading ? (
          <div className="p-4">
            <Loading />
          </div>
        ) : (
          <ContentComponentMedia
            type={this.state.type}
            typeName={this.state.typeName}
            typeIcon={this.state.typeIcon}
            typeColor={this.state.typeColor}
            types={this.state.types}
            currentRoute={this.props.currentRoute}
            serie={null}
            discipline={null}
            word={this.state.word}
            libraryMode
          />
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ logout, setObj }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ContentList);
